// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1AQKq","input":"styles_input__v6mkD"};